<template>
    <div class="category-card">
        <div class="row">
            <div class="col-lg-2 col-md-12 category-border-right">
                <div class="category-card-title">
                    <h2>{{category.title}}</h2>
                    <div class="category-card-list">
                        <ul>
                            <li v-for="(item,i) in category.list" :key="i">
                                <router-link :to="item.link">{{item.listitem}}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-10 col-md-12">
                <div class="category-content">
                    <offer-owl-carousel
                        :data="topBrandsCarousel.data"
                        :items="topBrandsCarousel.items"
                        :margin="topBrandsCarousel.margin"
                        :loop="topBrandsCarousel.loop"
                        :autoplay="topBrandsCarousel.autoplay"
                        :nav="topBrandsCarousel.nav"
                        :navText="topBrandsCarousel.navText"
                        :responsive="topBrandsCarousel.responsive"
                        :dots="topBrandsCarousel.dots"
                    />
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import carousel from 'vue-owl-carousel'

    export default {
        data() {
            return {
                category:{
                    title: 'electricity',
                    list: [
                        {listitem:'computer',link:'/computer'},
                        {listitem:'laptop',link:'/laptop'}
                    ]
                },
                topBrandsCarousel: {
                    data: [
                        {
                        img : "https://bit.ly/2Tp8nZB",
                        content : {
                            title      : "dummy title",
                            details    : "/product/id",
                            offerPrice : "$125.00",
                            oldPrice   : "",
                            btn        :  "add to cart",
                            link       :  "/"
                        }
                        },
                        {
                        img : "https://bit.ly/2Uh8XGe",
                        content : {
                            title      : "dummy title",
                            details    : "/product/id",
                            offerPrice : "$125.00",
                            oldPrice   : "",
                            btn        :  "add to cart",
                            link       :  "/"
                        }
                        },
                        {
                        img : "https://bit.ly/2VwFMz4",
                        content : {
                            title      : "dummy title",
                            details    : "/product/id",
                            offerPrice : "$125.00",
                            oldPrice   : "$250.00",
                            btn        :  "add to cart",
                            link       :  "/"
                        }
                        },
                        {
                        img : "https://bit.ly/2Uh8XGe",
                        content : {
                            title      : "dummy title",
                            details    : "/product/id",
                            offerPrice : "$125.00",
                            oldPrice   : "$250.00",
                            btn        :  "add to cart",
                            link       :  "/"
                        }
                        }

                    ],
                    items    : 3,
                    margin   : 10,
                    loop     : true,
                    autoplay : false,
                    nav      : true,
                    dots     : false,
                    navText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
                    responsive:{
                        0:{
                        items:1,
                        nav:false
                        },
                        640:{
                        items:2,
                        nav:true
                        },
                        992:{
                        items:2,
                        nav:true,
                        },
                        1199:{
                        items:3,
                        nav:true,
                        }
                    }
                }
            }
        }
    }
</script>

<style>
    .category-card {
        background: #fff;
    }
    .category-border-right{border-right:1px solid #ddd;}

    .category-card-title h2 {
        position: relative;
        font-size: 24px;
        text-transform: capitalize;
        padding: 15px;
    }

    .category-card-title h2:before {
        position: absolute;
        content: "";
        bottom: 0;
        left: 17px;
        width: 60px;
        height: 2px;
        background: #eb1b33;
    }

    .category-card-list ul li {
        text-transform: capitalize;
        font-size: 16px;
        padding: 0 15px;
    }

    .category-card-list ul li a {
        display: block;
    }

    .category-card .offer-content-body{margin-bottom: 0;}
</style>
